import { render } from "./TheDmsHeader.vue?vue&type=template&id=8a18574e&scoped=true&ts=true"
import script from "./TheDmsHeader.vue?vue&type=script&lang=ts"
export * from "./TheDmsHeader.vue?vue&type=script&lang=ts"

import "./TheDmsHeader.vue?vue&type=style&index=0&id=8a18574e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a18574e"]])

export default __exports__